<template>
  <div :class="{ active: isActive }" class="es-Item_OuterWrapper">
    <button @click="callPopulate" class="es-Item_Wrapper p-2 p-md-3 shadow-sm shadow-sm-hover">
      <div class="d-flex justify-content-between">
        <div class="flex-grow-1 pr-2">
          <p class="h6 mb-1">{{ item.title }}</p>
          <p class="text-xs mb-0">{{ item.vendor }}</p>
        </div>
        <div @click.stop class="flex-grow-0 flex-shrink-0 d-flex align-items-end flex-column">
          <ProductEssentialControls
            :quantity="optimisticQuantity"
            :increaseable="increasable"
            @decrease="callDecimate"
            @increase="callPopulate"
          />
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ProductEssentialControls from "./ProductEssentialControls";

export default {
  name: "ProductEssentialItem",
  components: {
    ProductEssentialControls,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
    lyticsActivities: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      optimisticQuantity: 0,
    };
  },
  computed: {
    ...mapGetters({
      getLineItem: "shoppingCart/getLineItem",
      isLoading: "shoppingCart/isLoading",
    }),
    increasable() {
      return this.optimisticQuantity < (this.item?.purchase_limit || 50);
    },
    quantity() {
      const lineItem = this.getLineItem(this.item.variant_id);
      return lineItem?.quantity ? lineItem.quantity : 0;
    },
    isActive() {
      return this.quantity > 0;
    },
  },
  watch: {
    quantity: {
      immediate: true,
      handler() {
        if (!this.isLoading) this.optimisticQuantity = this.quantity;
      },
    },
  },
  methods: {
    ...mapActions({
      addProductToCart: "shoppingCart/addProductToCart",
      removeProductFromCart: "shoppingCart/removeProductFromCart",
    }),
    callPopulate() {
      if (this.increasable) {
        this.optimisticQuantity = this.optimisticQuantity + 1;

        this.addProductToCart({
          variant_id: this.item.variant_id,
          lyticsActivities: this.lyticsActivities,
        });
      }
    },
    callDecimate() {
      if (this.optimisticQuantity > 0) {
        this.optimisticQuantity = this.optimisticQuantity - 1;
      }
      this.removeProductFromCart({
        variant_id: this.item.variant_id,
        lyticsActivities: this.lyticsActivities,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.es-Item_OuterWrapper {
  border-left: $width-border-thick solid transparent;
  width: 100%;
}

.es-Item_Wrapper {
  background: $white;
  text-align: left;
  border: 0;
  border-radius: $border-radius;
  width: 100%;
  height: 100%;

  &:focus {
    border: 0;
    outline: 0;
    box-shadow: $box-shadow-hover;
  }
}

.active {
  border-color: $success;
}
</style>
